import { Component, OnInit } from '@angular/core';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { DwmGenericServiceService } from '../_DWM-Generic-Services/generic-service.service';
import { ViewWillEnter } from '@ionic/angular';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { HomeQuickSearchPopupComponent } from 'src/app/shared/popups/home-quick-search-popup/home-quick-search-popup.component';
DwmGenericServiceService;

@Component({
  selector: 'app-dwm-tabs',
  templateUrl: './dwm-tabs.component.html',
  styleUrls: ['./dwm-tabs.component.scss']
})
export class DwmTabsComponent implements OnInit, ViewWillEnter {
  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserName: any;
  loggedInUserCompanyID: any;
  isRndAdminUser = false;
  loggedInUserId: string | null = null;
  userIsAdminTypes: any = null;
  allowedUserIds: string[] = ['7488', '7489', '7487'];

  constructor(
    private router: Router,
    private config: Config,
    private httpService: HttpService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<HomeQuickSearchPopupComponent>,
    private encryptionService: EncryptionService,
    private mobileResponsiveService: MobileResponsiveService,
    private dwmGenericServiceService: DwmGenericServiceService
  ) {}

  ngOnInit() {
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    const loggedUserRole = sessionStorage.getItem('loggedInUserRole');
     this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
     console.log('Loggedin User Role is..', this.loggedInUserRole);
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    console.log('Loggedin User Id is..', this.loggedInUserId);
    if (loggedUserRole) this.loggedInUserRole = this.encryptionService.decryptData(loggedUserRole);

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getDwmSetupData();
  }

  ionViewWillEnter() {
    this.userIsAdminTypes = this.dwmGenericServiceService.checkIsLoggedInUserIsAdmin();
  }

  mouseenterTriggerMenu(menuName: MatMenuTrigger) {
    if (window?.innerWidth > this.mobileResponsiveService?.minScreenSize?.lg992.size) menuName.openMenu();
  }

  // getDwmSetupData() {
  //   this.httpService.callGetService(`${this.config.getDwmSetup}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
  //     const setup = res?.data?.[0];

  //     if (setup?.rndAdmin && this.loggedInUserName) this.isRndAdminUser = setup.rndAdmin.trim().toLowerCase() === this.loggedInUserName.trim().toLowerCase();
  //     console.log('Is RnD Admin User:', this.isRndAdminUser);
  //   });
  // }

  getDwmSetupData() {
  this.httpService
    .callGetService(`${this.config.getDwmSetup}?companyId=${this.loggedInUserCompanyID}`)
    .subscribe((res: any) => {

      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;

    
      const currentFY =
        month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
      const currentSetup = res?.data?.find(
        (item: any) => item.fiscalYear === currentFY
      );

     
      this.isRndAdminUser =
        currentSetup?.rndAdmin?.trim().toLowerCase() ===
        this.loggedInUserName?.trim().toLowerCase();

      console.log('Current FY:', currentFY);
      console.log('Is RnD Admin:', this.isRndAdminUser);
    });
}

  // Ticketing URL
  onClickOpenTickets() {
    const tickets = `https://phiedgehrms.raiseaticket.com/support/#/login `;
    window.open(tickets, '_blank');
  }

  //  Resource Popup
  onClickResources(status: 'helpDesk') {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;

    dialogConfig.data = {
      statusCheck: status
    };

    dialogConfig.panelClass = 'custom-dialog-container';

    const dialogRef = this.dialog.open(HomeQuickSearchPopupComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {});
  }
}
